var map = {
	"./1voucher-light.svg": 9225,
	"./1voucher.svg": 2226,
	"./Shape.svg": 8750,
	"./account-light.svg": 9675,
	"./account-number-light.svg": 3993,
	"./account-number.svg": 1218,
	"./account.svg": 2064,
	"./active-enaira-option.svg": 8720,
	"./afrigo.svg": 1867,
	"./amex.svg": 8406,
	"./app_assets_img_mastercard.svg": 2387,
	"./apple-pay-logo-lg.svg": 5634,
	"./apple-pay-logo-sm.svg": 3053,
	"./applepay-light.svg": 2202,
	"./applepay.svg": 1633,
	"./bank-building-light.svg": 5065,
	"./bank-building.svg": 8018,
	"./bank-light.svg": 8370,
	"./bank.svg": 3209,
	"./banktransfer-light.svg": 6235,
	"./banktransfer.svg": 416,
	"./barter-light.svg": 4000,
	"./barter.svg": 1475,
	"./black-tick.svg": 5714,
	"./building-light.svg": 6784,
	"./building.svg": 4051,
	"./capitec-light.svg": 1717,
	"./capitec.svg": 3326,
	"./card-afrigo.svg": 670,
	"./card-amex.svg": 6347,
	"./card-dinersclub.svg": 2733,
	"./card-discover.svg": 9335,
	"./card-expiry-date.svg": 8648,
	"./card-light.svg": 6698,
	"./card-mastercard.svg": 2738,
	"./card-number-input-light.svg": 9925,
	"./card-number-input.svg": 5822,
	"./card-verve.svg": 5194,
	"./card-visa.svg": 3429,
	"./card.svg": 4817,
	"./cashback-icon.svg": 7387,
	"./change-payment.svg": 4150,
	"./close-mini.svg": 635,
	"./close.svg": 5837,
	"./copy.svg": 8552,
	"./credit-card-light.svg": 5824,
	"./credit-card.svg": 8531,
	"./cryptocurrency-light.svg": 1430,
	"./cryptocurrency.svg": 4909,
	"./cvv-info-en.svg": 2929,
	"./cvv-info-fr.svg": 3264,
	"./cvv-light.svg": 9509,
	"./cvv.svg": 1886,
	"./dinersclub.svg": 132,
	"./discover.svg": 9798,
	"./email-light.svg": 586,
	"./email.svg": 1089,
	"./enaira-light.svg": 4256,
	"./enaira.svg": 6019,
	"./fawrypay-light.svg": 8641,
	"./fawrypay.svg": 7818,
	"./globe-light.svg": 9897,
	"./globe.svg": 5938,
	"./go-back.svg": 5687,
	"./google-btn.svg": 157,
	"./google-pay-logo-lg.svg": 9861,
	"./google-pay-logo-sm.svg": 9782,
	"./googlepay-light.svg": 4671,
	"./googlepay.svg": 3668,
	"./inactive-enaira-option.svg": 2581,
	"./info-icon.svg": 6999,
	"./info-light.svg": 9056,
	"./internetbanking-light.svg": 6781,
	"./internetbanking.svg": 7494,
	"./language.svg": 8997,
	"./list-item.svg": 2221,
	"./location-light.svg": 8333,
	"./location.svg": 4310,
	"./lock-icon-light.svg": 5071,
	"./lock-icon.svg": 3972,
	"./mastercard.svg": 251,
	"./migo-light.svg": 4932,
	"./migo.svg": 7031,
	"./mobilemoney-light.svg": 7448,
	"./mobilemoney.svg": 411,
	"./new-visa.svg": 7279,
	"./nqr-light.svg": 8501,
	"./nqr.svg": 3102,
	"./null.svg": 2000,
	"./opay-light.svg": 4727,
	"./opay.svg": 9900,
	"./othercard.svg": 7537,
	"./paga-light.svg": 8825,
	"./paga.svg": 6338,
	"./password-light.svg": 6455,
	"./password.svg": 3612,
	"./payattitude-light.svg": 1758,
	"./payattitude.svg": 4357,
	"./paypal-light.svg": 5069,
	"./paypal.svg": 5110,
	"./plain.svg": 6569,
	"./promo.svg": 8524,
	"./qr-light.svg": 5385,
	"./qr.svg": 6690,
	"./redirect.svg": 4855,
	"./smart-phone-light.svg": 9426,
	"./smart-phone.svg": 601,
	"./state-light.svg": 1589,
	"./state.svg": 2814,
	"./success_mark.svg": 5908,
	"./timer-icon.svg": 8388,
	"./timer.svg": 9866,
	"./user-light.svg": 337,
	"./user.svg": 698,
	"./ussd-light.svg": 5437,
	"./ussd.svg": 2038,
	"./verve.svg": 6221,
	"./visa-logo.svg": 7076,
	"./visa.svg": 9468,
	"./wechat-light.svg": 1458,
	"./wechat.svg": 3225,
	"./zip-code-light.svg": 1601,
	"./zip-code.svg": 7786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;